import { render, staticRenderFns } from "./TemplateDoc.vue?vue&type=template&id=33f1ac98"
import script from "./TemplateDoc.vue?vue&type=script&lang=js"
export * from "./TemplateDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports